/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/** @jsx jsx */
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { Text, jsx } from 'theme-ui'
import CustomEmbed from '../../article/CustomEmbed'
import CustomLink, { DefaultLink } from '../../article/CustomLinkFeatureCard'
import checkFeatureVisibility from '../../../utils/checkFeatureVisibility'

export const optionFeatureCard = {
  renderText: text =>
    text.split('\n').flatMap((text, i) => [i > 0 && <br key={i} />, text]),
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children) => (
      <Text variant="h1" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_2]: (node, children) => (
      <Text variant="h2" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <Text variant="h3" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <Text variant="h4" as="h4" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <Text variant="h5" as="h5" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <Text variant="h6" as="h6" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Text variant="xSmallText" sx={{ mb: 5 }}>
        {children}
      </Text>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: ({ data }) => {
      return <CustomEmbed data={data} />
    },
    [BLOCKS.TABLE]: (node, children) => (
      <table>
        <tbody>{children}</tbody>
      </table>
    ),
    [BLOCKS.TABLE_ROW]: (node, children) => <tr>{children}</tr>,
    [BLOCKS.TABLE_CELL]: (node, children) => <td>{children}</td>,
    [BLOCKS.TABLE_HEADER_CELL]: (node, children) => <th>{children}</th>,
    [INLINES.HYPERLINK]: (node, children) => {
      if (
        node?.data?.uri ==
          'http://samplesite.commonwealth.com/easysite-requests' &&
        checkFeatureVisibility('Maintenance Package')
      ) {
        // feature-flag maintenance package
        node.data.uri = '/app/SupportPackage'
      }
      return (
        <CustomLink node={node.data} sx={{ mb: 5 }}>
          {children}
        </CustomLink>
      )
    },
    [INLINES.ENTRY_HYPERLINK]: node => {
      return (
        <DefaultLink
          uri={`#${node?.data?.target?.sys?.id}`}
          text={node?.content[0]?.value}
        />
      )
    },
  },
}
